/**
 * Created by mukund on 7/17/15.
 */

'use strict';

angular.module('mediacloudApp')
    .controller('QuizzingInstructorReportController', function($scope, $compile, $state, $stateParams, $window, $rootScope, $http, $filter, Principal, AssetService, CollectionService, AVMedia, $timeout) {

        Principal.identity().then(function(account) {
            $scope.account = account;
            var logger = function(msg) {
                var active = false;

                if (active) {
                    console.log(msg);
                }
            }

            var assetId = $state.params.assetId;
            var collectionId = $state.params.collectionId;
            var collectionType = 'course';
            var isNewQuiz = $state.params.isNewQuiz === "true";
            $scope.rootCollectionType = collectionType;
            $scope.isAssignmentFromLMS = sessionStorage.getItem('isAssignmentFromLMS') === "true";
            $scope.quiz = {};
            $scope.hasWritePermissions = false;
            $scope.breadcrumbLoaded = false;
            $scope.media = null;
            $scope.srcLang = "English";
            $scope.captionsIncluded = false;
            $scope.subtitlesIncluded = false;
            $scope.audioDescriptionsIncluded = false;
            $scope.updateTimeout = null;
            $scope.metadataloaded = false;
            $scope.hidingToolbar = false;
            $scope.currentWidth = 0;
            $scope.currentTextTrackFontSize = "0";
            $scope.playerEl;
            
            $scope.$watch("[breadcrumbLoaded, isPreview, isAssignmentFromLMS, hasWritePermissions]",
                function () {
                    if ($scope.breadcrumbLoaded) {
                        if ($scope.isAssignmentFromLMS && (!$scope.hasWritePermissions || $scope.isPreview)) {
                            $('.breadcrumb').css('visibility', 'hidden');
                        }else if ($scope.isAssignmentFromLMS && $scope.hasWritePermissions) {
                            $(".breadcrumb").each(function () {
                                var el = $(this);
                                el.addClass("non-interactive");
                                $timeout(function(){
                                    // Disable keyboard focusability for all children
                                    el.find("a, button, input, [tabindex]").each(function () {
                                        $(this).attr("tabindex", "-1");
                                        $(this).attr("disabled", true); // Only affects elements that support it
                                    });
                                    // Prevent Enter/Space key activation
                                    el.on("keydown", function (e) {
                                        if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }
                                    });
                                },0);
                            });
                            $('.breadcrumb').css('visibility', 'visible');
                        }
                    }
                },
                true
            );

            var player;
            var testVideo = false;
            var testHlsUrl = "";
            $http({method: 'GET', url: 'api/properties?name=TEST_VIDEO_HLS_URL'})
                .then(function (response) {
                    if (response.data.value != null && response.data.value.length > 0) {
                        testVideo = true;
                        testHlsUrl = response.data.value;
                        console.log("-------------Using Test Video-------------\ntestHlsUrl: " + testHlsUrl);
                    }
                });

            var loadPageInfo = function() {
                AssetService.GetAsset.get({
                    cid: collectionId,
                    aid: assetId
                }, function(asset) {
                    $scope.asset = asset;
                    $scope.rootCollectionId = $scope.asset.rootLevelCid;
                    $rootScope.rootLevelCid = $scope.asset.rootLevelCid;
                    $rootScope.rootCollectionId = $scope.asset.rootLevelCid;
                    $scope.hideCurrentFolderOnBreadcrumb = !$scope.rootCollectionId;
                    $scope.hasWritePermissions = $scope.asset.acl.indexOf('W') > -1;
                    if ($scope.hasWritePermissions) {
                        $scope.getQuizMetadata();
                    }
                    console.log('asset: ', $scope.asset);
                    $scope.getCollections();
                    AssetService.GetQuizInfo.get({
                        cid: $scope.asset.cid,
                        aid: $scope.asset.aid
                    }, function(quiz) {
                        $scope.mmQuiz = quiz;
                        console.log('mmQuiz: ', $scope.mmQuiz);
                        $scope.getAVMedia(quiz.originAid);
                    });
                });
            };

            $scope.hlsUrl = "";

            $scope.navigateUp = function() {
                $state.go("quizzing", {
                    isNewQuiz: false,
                    collectionType: 'course',
                    collectionId: $scope.quiz.collectionId,
                    assetId: $scope.quiz.assetId,
                    isFromPnP: false
                });
            }

            $scope.openStudentQuizReport = function (studentName) {
                $state.go("quizzingInstructorReportStudent", {
                    collectionId: $scope.quiz.collectionId,
                    assetId: $scope.quiz.assetId,
                    quizId: $scope.quiz.id,
                    userId: studentName
                });
            }

            $scope.getAVMedia = function (aid) {
                var AUTHTOKEN = $scope.$root.AUTHTOKEN;
                AVMedia.get(
                    {
                        cid: $scope.asset.cid,
                        aid: aid,
                    },
                    function (media) {
                        if (!player) {
                            $scope.media = media;
                            if(!testVideo){
                                $scope.hlsUrl =
                                    media.mediaUrl +
                                    "/playlist.m3u8?authToken=" +
                                    (AUTHTOKEN
                                        ? AUTHTOKEN
                                        : JSON.parse(
                                              localStorage.getItem(
                                                  "ls.authToken"
                                              )
                                          ));
                            }else{
                                $scope.hlsUrl = testHlsUrl;
                            }
                            $scope.initializeVideo(
                                "quizzing-report-video",
                                434,
                                244,
                                media
                            );
                        }
                    }
                );
            };

            $scope.twoDecimalPlaces = function(myNumber, preferInteger) {
               if (!myNumber) return myNumber;
               if (preferInteger && Number.isInteger(myNumber)) return myNumber;
               if (!isNaN(parseFloat(myNumber))) return parseFloat(myNumber).toFixed(2);
               return myNumber.toFixed(2);
            }

            $scope.getQuizMetadata = function() {
                AssetService.GetQuizMetadata.get({
                    cid: collectionId,
                    aid: assetId
                }, function(quiz) {
                    $scope.quiz = quiz;
                    console.log('quiz: ', $scope.quiz);
                    AssetService.GetQuizSummaryReport.get({
                        quizId: $scope.quiz.id,
                    }, function(response) {
                        console.log('GetQuizSummaryReport: ', response);
                        $scope.numSubmissions = response.numSubmissions;
                        $scope.averageScore = (response.averageScore * 100).toFixed(2);
                        $scope.possiblePoints = response.numPossiblePoints;
                        $scope.averagePoints = $scope.twoDecimalPlaces((response.averageScore * response.numPossiblePoints), true);
                    });
                    AssetService.GetQuizTakerBreakdownReport.get({
                        quizId: $scope.quiz.id,
                    }, function(response) {
                        console.log('GetQuizTakerBreakdownReport: ', response);
                        $scope.quizTakerList = response.quizTakerList;
                        $.each($scope.quizTakerList, function (k, quizTaker) {
                            if (quizTaker.dateSubmitted) {
                                quizTaker.dateSubmittedFormatted = moment(quizTaker.dateSubmitted).format("MMM. DD, YYYY hh:mm a");
                            }
                            else {
                                quizTaker.dateSubmittedFormatted = 'Not available';
                            }
                        });
                        $(document).ready(function() {
                            var datatable = $('#quizzing-report').DataTable({
                                "searching": true,
                                "paging": false,
                                "info": false,
                                "autoWidth": true,
                                "stripeClasses": [],
//                                "drawCallback": function (settings) {
//                                    if ($('#reportSearch').val() != "") {
//                                        $('#quizzing-report td .name').highlight($('#reportSearch').val());
//                                    }
//                                }
                            });
                           $('#reportSearch').keyup(function(){
                                if ($(this).val() != '') {
                                    $('.clear-btn').show();
                                }
                                else {
                                    $('.clear-btn').hide();
                                }
                                datatable.search($(this).val()).draw();
                            });

                            $('.clear-btn').click(function () {
                                datatable.search('').draw();
                                $('#reportSearch').val('');
                                $('.clear-btn').hide();
                            });

                            datatable.on('draw', function () {
                                var body = $('#quizzing-report td .name');
                                body.unhighlight();
                                body.highlight( datatable.search() );
                             });
                            if ($scope.hasWritePermissions) {
                                $('.quiz-page').show();
                                $("#asset-bg").css('background-image', 'url(' + $scope.asset.thumbnailUrl + ')');
                            }
                        });
                    });
                });
            }

            $scope.handleExportClick = function() {
                var separator = ',';
                var rows = document.querySelectorAll('table#quizzing-report tr');
                var csv = [];
                for (var i = 0; i < rows.length; i++) {
                    var row = [], cols = rows[i].querySelectorAll('td, th');
                    for (var j = 0; j < cols.length - 1; j++) {
                        var data = cols[j].innerText.substring(cols[j].innerText.indexOf('\n')+1).replace(/(\r\n|\n|\r)/gm, '').replace(/(\s\s)/gm, ' ');
                        data = data.replace(/"/g, '""');
                        row.push('"' + data + '"');
                    }
                    csv.push(row.join(separator));
                }
                var csv_string = csv.join('\n');
                var filename = $scope.asset.title + '_Report_' + new Date().toLocaleDateString() + '.csv';
                var link = document.createElement('a');
                link.style.display = 'none';
                link.setAttribute('target', '_blank');
                link.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv_string));
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }

            var manageBreadcrumbTruncation = function() {
                var assetTitleIntervalId = setInterval(function() {
                    if ($('.breadcrumb .asset-name .name').length) {
                        clearInterval(assetTitleIntervalId);

                        var breadcrumbInterval = setInterval(function() {
                            if (
                                $('.breadcrumb .sub-folder .name').height() > 0 ||
                                $('.breadcrumb .current-folder .name').height() > 0 ||
                                $('.breadcrumb .asset-name .name').height() > 0
                            ) {
                                clearInterval(breadcrumbInterval);

                                //If the breadcrumb is bigger than the max width
                                var isBreadcrumbBigger = $('.breadcrumb .sub-folder .name').height() > 28 ||
                                    $('.breadcrumb .current-folder .name').height() > 28 ||
                                    $('.breadcrumb .asset-name .name').height() > 28;

                                if (isBreadcrumbBigger) {
                                    //If each subfolder is bigger than the limit
                                    if (
                                        hasEllipsisWidth($('.breadcrumb .sub-folder')[0]) ||
                                        hasEllipsisWidth($('.breadcrumb .current-folder')[0]) ||
                                        hasEllipsisHeight($('.breadcrumb .asset-name')[0])
                                    ) {

                                        //Add ellipsis to subfolders that are wider than the limit
                                        $('.breadcrumb .sub-folder .name').addClass('truncate-ellipsis');
                                        $('.breadcrumb .sub-folder .name').addClass('limit-folder-size');
                                        $('.breadcrumb .current-folder .name').addClass('truncate-ellipsis');
                                        $('.breadcrumb .current-folder .name').addClass('limit-folder-size');

                                        //TODO: get player width - .root-container width
                                        var nameWidthIntervalId = setInterval(function() {
                                            if ($('.breadcrumb .root-collection .name').width()) {
                                                clearInterval(nameWidthIntervalId);

                                                var subFoldersWidth = 0;
                                                $('.breadcrumb .sub-folder').each(function(index, item) {
                                                    subFoldersWidth += $(item).width() + 16;
                                                });

                                                // var assetNameWidth = $('#player').width() - titleWidth - subFoldersWidth - 40;
                                                var assetNameWidth = 187;

                                                $('.breadcrumb .asset-name .name').addClass('truncate-ellipsis');
                                                $('.breadcrumb .asset-name .name').css('max-width', assetNameWidth.toString() + 'px');
                                            }
                                        }, 10)
                                    }

                                    $scope.showSubFolderTooltip = [];


                                    if ($('.breadcrumb .sub-folder').length > 0) {
                                        $scope.showSubFolderTooltip[0] = hasEllipsisWidth($('.breadcrumb .sub-folder .name')[0]);
                                    }

                                    if ($('.breadcrumb .sub-folder').length > 1) {
                                        $scope.showSubFolderTooltip[1] = hasEllipsisWidth($('.breadcrumb .sub-folder .name')[1]);
                                    }

                                    if ($('.breadcrumb .sub-folder').length > 2) {
                                        $scope.showSubFolderTooltip[2] = hasEllipsisWidth($('.breadcrumb .sub-folder .name')[2]);
                                    }
                                }

                                if (hasEllipsisWidth($('.breadcrumb .current-folder .name')[0])) {
                                    $scope.showCurrentFolderTooltip = true;
                                }

                                setTimeout(function() {
                                    if (hasEllipsisWidth($('.breadcrumb .asset-name .name')[0])) {
                                        $scope.showAssetTooltip = true;
                                    }
                                }, 1000)

                                $('.breadcrumb').css('opacity', 1);
                            }
                        }, 50)
                    }
                }, 10)
            }

            // recursive function that gets all parent nodes of a collection from the collection tree
            var getCrumbs = function (node, crumbs, cid, parents) {
                logger("getCrumbs");
                if (node.cid && parents.indexOf(node.cid) !== -1) {
                    crumbs.push({
                        title: node.title,
                        cid: node.cid,
                    });
                }
                angular.forEach(node.children, function (child) {
                    getCrumbs(child, crumbs, cid, parents);
                });
            };

            $scope.getCollections = function() {
                logger('getCollections')

                CollectionService.GetCollection.get({
                    cid: collectionId,
                    type: collectionType.toUpperCase()
                }, function(parentCollection) {
                    $scope.parent = parentCollection;
                    $scope.parentCollection = parentCollection;
                    $scope.currentCollection = parentCollection;
                    $scope.isMediaInboxCollection = $scope.currentCollection.type === 'dropbox' ||
                        $scope.currentCollection.type === 'assignment' ||
                        $scope.currentCollection.type === 'zoom';

                    var collectionTreeIntervalId = setInterval(function() {
                        if ($scope.collectionTree) {
                            clearInterval(collectionTreeIntervalId);
                            $scope.currentCollection.crumbs = generateCrumbs(parentCollection.cid, parentCollection.path);
                            $scope.showBreadcrumbEllipsis = $scope.currentCollection.crumbs.length > 1;

                            //show only last 2 subfolders
                            $scope.breadcrumbFolders = $scope.currentCollection.crumbs.slice($scope.currentCollection.crumbs.length - 1, $scope.currentCollection.crumbs.length);
                            $scope.breadcrumbLoaded = true;
                            $scope.crumbsForMenu = JSON.parse(JSON.stringify($scope.currentCollection.crumbs.slice(0, $scope.currentCollection.crumbs.length - 1)));

                            setTimeout(function() {
                                manageBreadcrumbTruncation();
                            }, 500)
                        }
                    }, 50);

                    $scope.currentCollection.pathLength = parentCollection.path.split('/').length;
                    var arrPath = parentCollection.path.split('/');
                    if (arrPath.length > 2) {

                        if ($scope.rootCollectionId) {
                            CollectionService.GetCollection.get({
                                cid: $scope.rootCollectionId,
                                type: collectionType.toUpperCase()
                            }, function(collection) {
                                $scope.collection = collection;
                                $rootScope.rootLevelCollectionTitle = collection.title;
                            });
                        }

                    } else {
                        if (!$scope.rootCollectionId) {
                            $scope.rootCollectionId = $scope.asset.cid;
                            collectionId = $scope.rootCollectionId;
                        }

                        CollectionService.GetCollection.get({
                            cid: $scope.rootCollectionId,
                            type: collectionType.toUpperCase()
                        }, function(collection) {
                            $scope.collection = collection;
                            $rootScope.rootLevelCollectionTitle = collection.title;
                        });
                    }
                });
            }

            loadPageInfo();

            $scope.getCollectionTree = function() {
                logger('getCollectionTree');

                var intervalId = setInterval(() => {
                    if ($scope.rootCollectionId) {
                        clearInterval(intervalId);
                        //rootCollectionId 2
                        CollectionService.GetCollectionTree.get({
                            cid: $scope.rootCollectionId
                        }, function(tree) {
                            $scope.collectionTree = tree;
                            $scope.collectionTree.show = false;
                            // $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "95%"});

                            //here
                        });
                    }
                }, 100)
            }

            var generateCrumbs = function(cid, path) {
                logger("generateCrumbs");

                var crumbs = [];
                if (path) {
                    var parents = path.split("/").slice(3);
                    if (parents.length && $scope.collectionTree) {
                        angular.forEach(
                            $scope.collectionTree.children,
                            function(node) {
                                getCrumbs(node, crumbs, cid, parents);
                            }
                        );
                    }
                }

                return crumbs;
            };

            var hasEllipsisHeight = function(el) {
                if (el.offsetHeight && el.scrollHeight) {
                    return el.offsetHeight < el.scrollHeight;
                }

                return null;
            }

            var hasEllipsisWidth = function(el) {
                if (el && el.offsetWidth && el.scrollWidth) {
                    return el.offsetWidth < el.scrollWidth;
                }

                return null;
            };

            $scope.getCollectionTree();

            $scope.handleBreadCrumbCurrentCollectionClick = function(cid) {
                $scope.navigateToCollection({
                    type: "Collection",
                    xid: cid,
                });
            };

            $scope.navigateToCollection = function (content) {
                logger("navigateToCollection");
                $scope.goBack(content);
            };

            $scope.goBack = function (content) {
                logger("goBack");
                if (
                    $scope.parent.type === "course" ||
                    $scope.parent.type === "collection" ||
                    $scope.parent.type === "dropbox" ||
                    $scope.parent.type === "assignment" ||
                    $scope.parent.type === "zoom"
                ) {
                    if ($scope.hideHeaderAndFooter) {
                        $state.go("lmsCourse", {
                            collectionId:
                                ($scope.collectionTree &&
                                    $scope.collectionTree.cid) ||
                                $scope.currentCollection.cid,
                            items: [],
                            type: "",
                            destinationFolderId: content.xid,
                            destinationFolderCollectionTree:
                                $scope.collectionTree,
                        });
                    } else {
                        $state.go("course", {
                            collectionId:
                                ($scope.collectionTree &&
                                    $scope.collectionTree.cid) ||
                                $scope.currentCollection.cid,
                            items: [],
                            type: "",
                            destinationFolderId: content.xid,
                            destinationFolderCollectionTree:
                                $scope.collectionTree,
                        });
                    }
                } else if ($scope.parent.type === "channel") {
                    $state.go("channel", {
                        collectionId:
                            ($scope.collectionTree &&
                                $scope.collectionTree.cid) ||
                            $scope.currentCollection.cid,
                        items: [],
                        type: "",
                        destinationFolderId: content.xid,
                        destinationFolderCollectionTree:
                            $scope.collectionTree,
                    });
                } else if (
                    $scope.parent.type === "protected" ||
                    $scope.parent.type === "reserves"
                ) {
                    $state.go("protected", {
                        collectionId:
                            ($scope.collectionTree &&
                                $scope.collectionTree.cid) ||
                            $scope.currentCollection.cid,
                        items: [],
                        type: "",
                        destinationFolderId: content.xid,
                        destinationFolderCollectionTree:
                            $scope.collectionTree,
                    });
                }
            };

            $scope.handleBreadcrumbRootContainerClick = function(cid) {
                $scope.navigateToCollection({type: 'Collection', xid: cid})
            }

            $scope.handleParentQuizClick = function() {
                $state.go("quizzing", {
                    isNewQuiz: false,
                    collectionType: $scope.currentCollection.type,
                    collectionId: $scope.asset.cid,
                    assetId: $scope.asset.aid,
                    isFromPnP: false
                });
            };

            $scope.convertSRTtoVTT = function(srt) {
               return 'WEBVTT\n\n' + srt
                 .replace(/\r+/g, '')
                 .replace(/(\d+)\n(\d{2}:\d{2}:\d{2}),(\d{3}) --> (\d{2}:\d{2}:\d{2}),(\d{3})/g,
                   '$1\n$2.$3 --> $4.$5')
                 .replace(/\n\n\n+/g, '\n\n');
            }

            $scope.initializeVideo = function(playerId, width, height, media) {
                console.log("initializeVideo(" + playerId + ")");
                if (playerId) {
                    //Dispose of any player with the same Id
                    var allPlayers = videojs.getPlayers();
                    for (var tempPlayerId in allPlayers) {
                        var playerTemp = allPlayers[tempPlayerId];
                        if (playerTemp && playerId === tempPlayerId) {
                            playerTemp.dispose();
                        }
                    }
                    var videoOptions = {
                        crossOrigin: 'anonymous',
                        controls: true,
                        autoplay: false,
                        fluid: true,
                        aspectRatio: '16:9',
                        preload: "auto",
                        playbackRates: [2, 1.5, 1, 0.5, 0.25],
                        inactivityTimeout: 5000,
                        width: "auto",
                        noUITitleAttributes: true,
                        controlBar: {
                            skipButtons: {
                                forward: 10,
                                backward: 10
                            }
                        },
                        poster: $scope.asset.thumbnailUrl,
                        textTrackSettings: false,
                        playsinline: true,
                        html5: {
                            nativeTextTracks: false
                        }
                    };
                    //for iOS use nativeTextTracks and nativeTextTracks styling
                    if(videojs.browser.IS_IOS){
                        videoOptions.html5.nativeTextTracks = true;
                        $(".video-js-custom.video-js").addClass("vjs-is-ios");
                    }
                    //initialize player
                    player = videojs(playerId, videoOptions);

                    player.src({
                        type: "application/x-mpegURL",
                        src: $scope.hlsUrl,
                    });

                    /*
                    player.spriteThumbnails({
                        url: $scope.asset.thumbnailUrl,
                        width: 100,
                        height: 56,
                        columns: 2
                    });
                    */

                    player.on("loadedmetadata", function () {
                        $scope.metadataloaded = true;
                        $scope.updateAudioTrackIcon();
                        player.trigger('playerresize');
                    });

                    player.on("ratechange", function () {
                        var rate = player.playbackRate().toString().replace(".","_");
                        //console.log("rate: "+rate);
                        $(".video-js-custom.video-js .vjs-playback-rate button").removeClass(
                                "vjs-rate-2 vjs-rate-1_5 vjs-rate-1 vjs-rate-0_5 vjs-rate-0_25"
                        ).addClass(
                            "vjs-rate-" + rate
                        );
                    });

                    player.audioTracks().addEventListener('addtrack', function(event) {
                        $timeout(function(){
                            $scope.updateAudioTrackIcon();
                        },0);
                    });
                    player.audioTracks().on("change", function(event) {
                        $scope.updateAudioTrackIcon();
                    });

                    player.on('durationchange', function() {
                        if(player.duration()>0){
                            $(".video-js-custom.video-js").addClass("vjs-times-loaded");
                        }
                    });

                    player.ready(function () {
                        console.log("Player is Ready!");

                        //Disable Picture in Picture
                        $(".video-js-custom.video-js video").attr(
                            "disablepictureinpicture",
                            ""
                        );

                        // initialize captions
                        $.each(JSON.parse($scope.media.captions), function (i, k) {
                            var trackKind = "";
                            if(k.title.includes("Audio Description")){
                                k.title = k.title.replace("(Audio Description)","[AD]");
                                trackKind = 'subtitles';
                                $scope.audioDescriptionsIncluded = true;
                            } else if (k.language === $scope.srcLang) {
                                k.title += " [CC]";
                                trackKind = 'captions';
                                $scope.captionsIncluded = true;
                            } else  if (k.language !== $scope.srcLang) {
                                trackKind = 'subtitles';
                                $scope.subtitlesIncluded = true;
                            }
                            k.captionUrl = $scope.media.captionUrl + '&id=' + k.id;
                            if (k.fileName && k.fileName.includes(".srt")) {
                                // convert srt to vtt
                                $.ajax({
                                    url: k.captionUrl,
                                    type: 'GET',
                                    dataType: 'text',
                                    async: false,
                                    success: function(data) {
                                        const vttText = $scope.convertSRTtoVTT(data);
                                        const vttBlob = new Blob([vttText], { type: 'text/vtt' });
                                        const vttUrl = URL.createObjectURL(vttBlob);

                                        player.addRemoteTextTrack({
                                            kind: trackKind,
                                            src: vttUrl,
                                            srclang: k.language,
                                            label: k.title,
                                            default: true
                                        }, false);
                                    },
                                    error: function(xhr, status, error) {
                                        console.error('Failed to load subtitles:', error);
                                    }
                                });
                            }else {
                                // add vtt directly
                                player.addRemoteTextTrack({
                                    kind: trackKind,
                                    src: k.captionUrl,
                                    srclang: k.language,
                                    label: k.title,
                                    default: true
                                }, false);
                            }
                        });

                        //Text track listener
                        var textTrackList = player.textTracks();

                        textTrackList.addEventListener('change', function() {
                            var isShowing = false;
                            for (var i = 0; i < textTrackList.length; i++) {
                                var track = textTrackList[i];
                                if (track.mode === 'showing') {
                                    isShowing = true;
                                    break;
                                }
                            }
                            if(isShowing){
                                $(".video-js-custom.video-js").addClass("vjs-showing-subs-caps");
                            }else{
                                $(".video-js-custom.video-js").removeClass("vjs-showing-subs-caps");
                            }
                            if($scope.captionsIncluded && !$scope.subtitlesIncluded && !$scope.audioDescriptionsIncluded){
                                $(".video-js-custom.video-js").addClass("vjs-subs-caps-alt");
                                if(isShowing){
                                    $(".video-js-custom.video-js .vjs-subs-caps-button-toggle .vjs-tooltip").html("Turn off captions");
                                    $(".video-js-custom.video-js .vjs-subs-caps-button-toggle .vjs-control-text").html("Turn off captions");
                                }else{
                                    $(".video-js-custom.video-js .vjs-subs-caps-button-toggle .vjs-tooltip").html("Turn on captions");
                                    $(".video-js-custom.video-js .vjs-subs-caps-button-toggle .vjs-control-text").html("Turn on captions");
                                }
                            }else{
                                $(".video-js-custom.video-js").removeClass("vjs-subs-caps-alt");
                            }
                        });
                        
                        //Add Progress Mask and Bar
                        $(
                            '.video-js-custom.video-js .vjs-progress-control.vjs-control'
                        ).append('<div class="vjs-progress-mask"><div class="vjs-play-progress-bar"></div></div>');

                        //Add Progress Elypse
                        $(
                            '.video-js-custom.video-js .vjs-play-progress.vjs-slider-bar'
                        ).append('<div class="vjs-progress-point"></div>');

                        //Add mute tooltip and polygon
                        $(
                            '.video-js-custom.video-js .vjs-mute-control'
                        ).append(
                            '<div class="vjs-tooltip" aria-hidden="true"></div><div class="vjs-polygon" aria-hidden="true" ></div>'
                        );
                        $(".video-js-custom.video-js .vjs-mute-control")
                            .on("mouseenter",function(event) {
                            $scope.showTooltip(event);
                        }).on("mouseleave",function(event) {
                            $scope.hideTooltip(event);
                        }).on("focus",function(event) {
                            $scope.showTooltip(event);
                        }).on("blur",function(event) {
                            $scope.hideTooltip(event);
                        }).keydown(function(event) {
                            if(27===event.which){
                                $(".vjs-button").removeClass("vjs-tooltip-show");
                            }
                        });

                        //Add volume bar background
                        $(".video-js-custom.video-js .vjs-volume-control").prepend('<div class="vjs-vol-bar-start"></div>');
                        $(".video-js-custom.video-js .vjs-volume-control").append('<div class="vjs-vol-bar-end"></div>');

                        //Add volume control tooltip and polygon
                        $('.video-js-custom.video-js .vjs-volume-control').append('<div class="vjs-tooltip" aria-hidden="true">Volume</div><div class="vjs-polygon" aria-hidden="true" ></div>');
                        $(".video-js-custom.video-js .vjs-volume-control")
                          .on("mouseenter", function (event) {
                            $scope.showTooltip(event);
                        }).on("mouseleave", function (event) {
                            $scope.hideTooltip(event);
                        }).keydown(function (event) {
                            if (27 === event.which) {
                                $(".vjs-button").removeClass("vjs-tooltip-show");
                            }
                        });

                        $(".video-js-custom.video-js .vjs-volume-control .vjs-volume-bar")
                          .on("focus", function (event) {
                            $scope.showTooltip(event);
                        }).on("blur", function (event) {
                            $scope.hideTooltip(event);
                        });

                        //Add play control polygon
                        $(
                            '.video-js-custom.video-js .vjs-play-control'
                        ).append(
                            '<div class="vjs-tooltip" aria-hidden="true"></div><div class="vjs-polygon" aria-hidden="true" ></div>'
                        );
                        $(".video-js-custom.video-js .vjs-play-control")
                            .on("mouseenter",function(event) {
                            $scope.showTooltip(event);
                        }).on("mouseleave",function(event) {
                            $scope.hideTooltip(event);
                        }).on("focus",function(event) {
                            $scope.showTooltip(event);
                        }).on("blur",function(event) {
                            $scope.hideTooltip(event);
                        }).keydown(function(event) {
                            if(27===event.which){
                                $(".vjs-button").removeClass("vjs-tooltip-show");
                            }
                        });

                        //Add playback rate tooltip and polygon
                        $(
                            '.video-js-custom.video-js .vjs-playback-rate button'
                        ).append(
                            '<div class="vjs-tooltip" aria-hidden="true">Change playback speed</div><div class="vjs-polygon" aria-hidden="true" ></div>'
                        );

                        $(".video-js-custom.video-js .vjs-playback-rate button")
                          .attr("aria-haspopup","menu")
                          .attr("id","vjs-playback-rate-button-id")
                          .attr("aria-controls","vjs-playback-rate-menu-id")
                          .on("mouseenter",function(event) {
                            $scope.showTooltip(event);
                        }).on("mouseleave",function(event) {
                            $scope.hideTooltip(event);
                        }).on("focus",function(event) {
                            $scope.showTooltip(event);
                        }).on("blur",function(event) {
                            $scope.hideTooltip(event);
                        }).keydown(function(event) {
                            if(27===event.which){
                                $(".vjs-button").removeClass("vjs-tooltip-show");
                            }else if(38===event.which || 40===event.which){
                                event.preventDefault();
                                event.stopPropagation();
                                $(event.target).click();
                                var keydownMenuIndex = $(".video-js-custom.video-js .vjs-playback-rate .vjs-menu .vjs-selected").index();
                                if(keydownMenuIndex>=0){
                                    player.controlBar.playbackRateMenuButton.menu.focus(keydownMenuIndex);
                                }else{
                                    var menu = player.controlBar.playbackRateMenuButton.menu;
                                    if(38===event.which ){
                                        menu.focus(menu.children().length-1);
                                    }else{
                                        menu.focus(0);
                                    }
                                }
                            }
                        }).on("pointerup",function(event) {
                            $timeout(function(){
                                if($(".video-js-custom.video-js .vjs-playback-rate .vjs-menu.vjs-lock-showing").length){
                                    var menuIndex = $(".video-js-custom.video-js .vjs-playback-rate .vjs-menu .vjs-selected").index();
                                    if(menuIndex<0){menuIndex = 0;}
                                    player.controlBar.playbackRateMenuButton.menu.focus(menuIndex);
                                }else{
                                    $(".video-js-custom.video-js .vjs-playback-rate button").focus();
                                }
                            });
                        }).on("pointerdown",function(event){
                            event.preventDefault();
                            event.stopPropagation();
                        });
                        $(".video-js-custom.video-js .vjs-playback-rate .vjs-menu")
                          .attr("id","vjs-playback-rate-menu-id")
                          .attr("aria-labelledby","vjs-playback-rate-button-id");

                        //add closed captions tooltip and polygon
                        $(
                            '.video-js-custom.video-js .vjs-subs-caps-button button'
                        ).append(
                            '<div class="vjs-tooltip" aria-hidden="true">Captions and subtitles</div><div class="vjs-polygon" aria-hidden="true" ></div>'
                        );

                        $(".video-js-custom.video-js .vjs-subs-caps-button button")
                          .attr("aria-haspopup","menu")
                          .attr("id","vjs-subs-caps-button-id")
                          .attr("aria-controls","vjs-subs-caps-menu-id")
                          .on("mouseenter",function(event) {
                            $scope.showTooltip(event);
                        }).on("mouseleave",function(event) {
                            $scope.hideTooltip(event);
                        }).on("focus",function(event) {
                            $scope.showTooltip(event);
                        }).on("blur",function(event) {
                            $scope.hideTooltip(event);
                        }).keydown(function(event) {
                            if(27===event.which){
                                $(".vjs-button").removeClass("vjs-tooltip-show");
                            }else if(38===event.which || 40===event.which){
                                event.preventDefault();
                                event.stopPropagation();
                                $(event.target).click();
                                var keydownMenuIndex = $(".video-js-custom.video-js .vjs-subs-caps-button .vjs-menu .vjs-selected").index();
                                if(keydownMenuIndex>=0){
                                    player.controlBar.subsCapsButton.menu.focus(keydownMenuIndex);
                                }else{
                                    var menu = player.controlBar.subsCapsButton.menu;
                                    if(38===event.which ){
                                        menu.focus(menu.children().length-1);
                                    }else{
                                        menu.focus(0);
                                    }
                                }
                            }
                        }).on("pointerup",function(event) {
                            $timeout(function(){
                                if($(".video-js-custom.video-js .vjs-subs-caps-button .vjs-menu.vjs-lock-showing").length){
                                    var menuIndex = $(".video-js-custom.video-js .vjs-subs-caps-button .vjs-menu .vjs-selected").index();
                                    if(menuIndex<0){menuIndex = 0;}
                                    player.controlBar.subsCapsButton.menu.focus(menuIndex);
                                }else{
                                    $(".video-js-custom.video-js .vjs-subs-caps-button button").focus();
                                }
                            });
                        }).on("pointerdown",function(event){
                            event.preventDefault();
                            event.stopPropagation();
                        });
                        $(".video-js-custom.video-js .vjs-subs-caps-button .vjs-menu")
                          .attr("id","vjs-subs-caps-menu-id")
                          .attr("aria-labelledby","vjs-subs-caps-button-id");

                        //add audio tooltip and polygon
                        $(
                            '.video-js-custom.video-js .vjs-audio-button button'
                        ).append(
                            '<div class="vjs-tooltip" aria-hidden="true">Audio track</div><div class="vjs-polygon" aria-hidden="true" ></div>'
                        );

                        $(".video-js-custom.video-js .vjs-audio-button button")
                          .attr("aria-haspopup","menu")
                          .attr("id","vjs-audio-button-id")
                          .attr("aria-controls","vjs-audio-menu-id")
                          .on("mouseenter",function(event) {
                            $scope.showTooltip(event);
                        }).on("mouseleave",function(event) {
                            $scope.hideTooltip(event);
                        }).on("focus",function(event) {
                            $scope.showTooltip(event);
                        }).on("blur",function(event) {
                            $scope.hideTooltip(event);
                        }).keydown(function(event) {
                            if(27===event.which){
                                $(".vjs-button").removeClass("vjs-tooltip-show");
                            }else if(38===event.which || 40===event.which){
                                event.preventDefault();
                                event.stopPropagation();
                                $(event.target).click();
                                var keydownMenuIndex = $(".video-js-custom.video-js .vjs-audio-button .vjs-menu .vjs-selected").index();
                                if(keydownMenuIndex>=0){
                                    player.controlBar.audioTrackButton.menu.focus(keydownMenuIndex);
                                }else{
                                    var menu = player.controlBar.audioTrackButton.menu;
                                    if(38===event.which ){
                                        menu.focus(menu.children().length-1);
                                    }else{
                                        menu.focus(0);
                                    }
                                }
                            }
                        }).on("pointerup",function(event) {
                            $timeout(function(){
                                if($(".video-js-custom.video-js .vjs-audio-button .vjs-menu.vjs-lock-showing").length){
                                    var menuIndex = $(".video-js-custom.video-js .vjs-audio-button .vjs-menu .vjs-selected").index();
                                    if(menuIndex<0){menuIndex = 0;}
                                    player.controlBar.audioTrackButton.menu.focus(menuIndex);
                                }else{
                                    $(".video-js-custom.video-js .vjs-audio-button button").focus();
                                }
                            });
                        }).on("pointerdown",function(event){
                            event.preventDefault();
                            event.stopPropagation();
                        });
                        $(".video-js-custom.video-js .vjs-audio-button .vjs-menu")
                          .attr("id","vjs-audio-menu-id")
                          .attr("aria-labelledby","vjs-audio-button-id");

                        //Add skip backward tooltip and polygon
                        $(
                            '.video-js-custom.video-js .vjs-skip-backward-10'
                        ).append(
                            '<span class="vjs-tooltip" aria-hidden="true">Step back 10 seconds</span><div class="vjs-polygon" aria-hidden="true" ></div>'
                        );
                        $(".video-js-custom.video-js .vjs-skip-backward-10")
                            .on("mouseenter",function(event) {
                            $scope.showTooltip(event);
                        }).on("mouseleave",function(event) {
                            $scope.hideTooltip(event);
                        }).on("focus",function(event) {
                            $scope.showTooltip(event);
                        }).on("blur",function(event) {
                            $scope.hideTooltip(event);
                        }).keydown(function(event) {
                            if(27===event.which){
                                $(".vjs-button").removeClass("vjs-tooltip-show");
                            }
                        });

                        //Add skip forward tooltip and polygon
                        $(
                            '.video-js-custom.video-js .vjs-skip-forward-10'
                        ).append(
                            '<span class="vjs-tooltip" aria-hidden="true">Step forward 10 seconds</span><div class="vjs-polygon" aria-hidden="true" ></div>'
                        );
                        $(".video-js-custom.video-js .vjs-skip-forward-10")
                            .on("mouseenter",function(event) {
                            $scope.showTooltip(event);
                        }).on("mouseleave",function(event) {
                            $scope.hideTooltip(event);
                        }).on("focus",function(event) {
                            $scope.showTooltip(event);
                        }).on("blur",function(event) {
                            $scope.hideTooltip(event);
                        }).keydown(function(event) {
                            if(27===event.which){
                                $(".vjs-button").removeClass("vjs-tooltip-show");
                            }
                        });

                        //Add fullscreen tooltip and polygon
                        $(
                            '.video-js-custom.video-js .vjs-fullscreen-control'
                        ).append(
                            '<span class="vjs-tooltip" aria-hidden="true"></span><div class="vjs-polygon" aria-hidden="true" ></div>'
                        );
                        $(".video-js-custom.video-js .vjs-fullscreen-control")
                            .on("mouseenter",function(event) {
                            $scope.showTooltip(event);
                        }).on("mouseleave",function(event) {
                            $scope.hideTooltip(event);
                        }).on("focus",function(event) {
                            $scope.showTooltip(event);
                        }).on("blur",function(event) {
                            $scope.hideTooltip(event);
                        }).keydown(function(event) {
                            if(27===event.which){
                                $(".vjs-button").removeClass("vjs-tooltip-show");
                            }
                        });

                        //Reorder DOM
                        $('.vjs-progress-control.vjs-control').insertBefore(
                            '.vjs-play-control'
                        );
                        $(
                            '.vjs-subs-caps-button.vjs-menu-button.vjs-menu-button-popup.vjs-control.vjs-button'
                        ).insertAfter(
                            '.vjs-duration.vjs-time-control.vjs-control'
                        );
                        $(
                            '.vjs-audio-button.vjs-menu-button.vjs-menu-button-popup.vjs-control.vjs-button'
                        ).insertAfter(
                            '.vjs-subs-caps-button.vjs-menu-button.vjs-menu-button-popup.vjs-control.vjs-button'
                        );
                        $(
                            '.vjs-playback-rate.vjs-menu-button.vjs-menu-button-popup.vjs-control.vjs-button'
                        ).insertAfter(
                            '.vjs-audio-button.vjs-menu-button.vjs-menu-button-popup.vjs-control.vjs-button'
                        );
                        $(
                            '.vjs-fullscreen-control.vjs-control.vjs-button'
                        ).insertAfter(
                            '.vjs-playback-rate.vjs-menu-button.vjs-menu-button-popup.vjs-control.vjs-button'
                        );
 
                        // Escaping Tooltips from scrubber
                        $(".video-js-custom.video-js .vjs-progress-holder")
                          .keydown(function (event) {
                            if (27 === event.which) {
                                $(".vjs-button").removeClass("vjs-tooltip-show");
                            }
                        });

                        //Update vjs-control-text items
                        $('.video-js-custom.video-js .vjs-skip-backward-10 .vjs-control-text').html('Step back 10 seconds');
                        $('.video-js-custom.video-js .vjs-subs-caps-button .vjs-control-text').html('Captions and subtitles');
                        $(".video-js-custom.video-js .vjs-playback-rate .vjs-control-text").html("Change Playback speed");


                        //Add aria labels to various buttons
                        $('.vjs-big-play-button').attr('aria-label', 'Play');
                        
                        $(".video-js-custom.video-js .vjs-big-play-button")
                          .keydown(function (event) {
                            if (27 === event.which) {
                                $(".vjs-button").removeClass("vjs-tooltip-show");
                            }
                        });

                        //Modify subs caps dialog
                        $(".video-js-custom.video-js .vjs-subs-caps-button .vjs-menu-content .vjs-menu-item-text:contains('captions off')").html("Off");

                        //Create caps toggle button
                        $("div.vjs-subs-caps-button").prepend(
                                '<button class="vjs-subs-caps-button-toggle vjs-control vjs-button" type="button">'+
                                '<span class="vjs-icon-placeholder" aria-hidden="true"></span>'+
                                '<span class="vjs-control-text" aria-live="polite">Captions and subtitles</span>'+
                                '<div class="vjs-tooltip" aria-hidden="true">Captions and subtitles</div>'+
                                '<div class="vjs-polygon" aria-hidden="true"></div>'+
                                '</button>');

                        $(".video-js-custom.video-js .vjs-subs-caps-button-toggle")
                          .on("mouseenter",function(event) {
                            $scope.showTooltip(event);
                        }).on("mouseleave",function(event) {
                            $scope.hideTooltip(event);
                        }).on("focus",function(event) {
                            $scope.showTooltip(event);
                        }).on("blur",function(event) {
                            $scope.hideTooltip(event);
                        }).keydown(function(event) {
                            if(27===event.which){
                                $(".vjs-button").removeClass("vjs-tooltip-show");
                            }
                        }).mousedown(function(event){
                            $scope.toggleCC();
                        }).keypress(function(event){
                            if(event.which===32 || event.which===13){
                                $scope.toggleCC();
                            }
                        });

                        //Create filler div
                        $('<div class="vjs-filler"></div>').insertAfter(".vjs-duration.vjs-time-control.vjs-control");

                        //Catch menu keydown and set focus
                        $(".vjs-menu .vjs-menu-item").on("keydown.instructorreport", function(event){
                            if(27===event.which){
                                $(".vjs-menu.vjs-lock-showing").parent().children("button:visible").focus();
                            }
                        });

                        //Prevent tooltip clicks
                        $(".vjs-tooltip").on('click', function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                        });

                        //Prevent polygon clicks
                        $(".vjs-polygon").on('click', function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                        });
                        
                        //Start player resizeOoserver
                        $scope.playerEl = player.el();
                        $scope.resizeObserver.observe($scope.playerEl);
                        
                        //start constantUpdates
                        $scope.makeUpdate();
                    });
                }
            };
            $scope.resizeObserver = new ResizeObserver((entries) => {
                for (var entry of entries) {
                    if (entry.contentBoxSize) {
                        var newWidth = parseInt(entry.contentBoxSize[0].inlineSize);
                        var newSize="";
                        if(newWidth<=399){
                            newSize="XS";
                            }else if(newWidth<=479){
                            newSize="S";
                        }else if(newWidth<=1023){
                            newSize="M";
                        }else{
                            newSize="L";
                        }
                        if($(".video-js-custom.video-js:not(.vjs-size-" + newSize + ")")){
                            $(".video-js-custom.video-js").removeClass("vjs-size-XS vjs-size-S vjs-size-M vjs-size-L").addClass("vjs-size-"+newSize);
                        }
                        if(newSize==="XS"||newSize==="S"){
                            $(".video-js-custom.video-js:not(.vjs-volume-popover)").addClass("vjs-volume-popover");
                        }else{
                            $(".video-js-custom.video-js.vjs-volume-popover").removeClass("vjs-volume-popover");
                        }
                        if(newSize === "M"){
                            var audioBarLength = Math.round(((newWidth - 480) / (1023 - 480) * 25) + 75);
                            if(audioBarLength !== $(".video-js-custom.video-js .vjs-filler").width()){
                                $(".video-js-custom.video-js .vjs-volume-bar.vjs-slider-horizontal").width(audioBarLength);
                                $(".video-js-custom.video-js .vjs-filler").width(audioBarLength);
                            }
                        }else{
                            if($(".video-js-custom.video-js .vjs-filler").get(0).style.width){
                                $(".video-js-custom.video-js .vjs-volume-bar.vjs-slider-horizontal").css("width", "");
                                $(".video-js-custom.video-js .vjs-filler").css("width", "");
                            }
                        }
                        if(!videojs.browser.IS_IOS){
                            var fontSize = null;
                            switch (newSize) {
                                case 'XS':
                                    fontSize = "14.00";
                                    break;
                                case 'S':
                                    fontSize = (((newWidth - 400) * 0.025316456) + 14).toFixed(2);
                                    break;
                                case 'M':
                                    fontSize = (((newWidth - 480) * 0.007366483) + 16).toFixed(2);
                                    break;
                                case 'L':
                                    fontSize = (((newWidth - 1024) * 0.017857143) + 20).toFixed(2);
                                    if(newWidth > 1920){
                                        fontSize = "36.00";
                                    }
                                    break;
                                default:
                            }
                            var currentFontPercent = $(".vjs-font-percent > select").val();
                            if(currentFontPercent && currentFontPercent !== "1.00"){
                                fontSize = (parseFloat(fontSize)*parseFloat(currentFontPercent)).toFixed(2);
                            }
                            if(fontSize !== $scope.currentTextTrackFontSize){
                                //console.log("fontSize change from " +$scope.currentTextTrackFontSize + " to " + fontSize );
                                $("#video-js-captions-styles").html(
                                       ".video-js-custom.video-js .vjs-text-track-display .vjs-text-track-cue {font-size: " +fontSize + "px !important;}"
                                );
                                $scope.currentTextTrackFontSize = fontSize;
                            }
                            if(newWidth !== $scope.currentWidth){
                                //console.log("update textTracks");
                                $scope.currentWidth = newWidth;
                                player.trigger('playerresize');
                            }
                        }
                    } 
                }
            });
            
            $scope.makeUpdate = function() {
                if($(".video-js-custom.video-js .vjs-play-progress-bar").css('width')!==$(".video-js-custom.video-js .vjs-play-progress").css( "width" )){
                    $(".video-js-custom.video-js .vjs-play-progress-bar").css('width', $(".video-js-custom.video-js .vjs-play-progress").css( "width" ));
                }
                var progressHolder = $(
                    ".video-js-custom.video-js .vjs-progress-holder"
                );
                var tooltips = $(".vjs-tooltip");
                $.each(tooltips, function () {
                    $(this).css("left", "");
                    var tooltipWidth = $(this).outerWidth();
                    var offset = Math.round(tooltipWidth / 2);
                    var tooltipParent = $(this).parent();
                    var parentOffset = Math.round(tooltipParent.outerWidth() / 2);
                    var left = tooltipParent.offset().left + parentOffset;
                    var tooltipLeftDif = parseInt(
                        left - progressHolder.offset().left
                    );if (tooltipLeftDif < 10) {
                        tooltipLeftDif = 10;
                    }
                    var tooltipRightDif = parseInt(
                        progressHolder.offset().left +
                            progressHolder.width() -
                            left
                    );
                    if (tooltipRightDif < 10) {
                        tooltipRightDif = 10;
                    }
                    if (tooltipLeftDif < offset) {
                        offset = tooltipLeftDif - parentOffset;
                        if (offset > 0) {
                            $(this).css("left", "-" + offset + "px");
                        }
                    } else if (tooltipRightDif < offset) {
                        offset = 2 * offset - tooltipRightDif - parentOffset;
                        if (offset > 0) {
                            $(this).css("left", "-" + offset + "px");
                        }
                    }
                });
                if($(".video-js-custom.video-js.vjs-showing-menu").length){
                    $(".video-js-custom.video-js:not(:has(.vjs-menu.vjs-lock-showing))").removeClass("vjs-showing-menu");
                }else{
                    $(".video-js-custom.video-js:has(.vjs-menu.vjs-lock-showing)").addClass("vjs-showing-menu");
                }
                //Update textTrackDisplay when toolbar changes visibility
                if($scope.hidingToolbar){
                    if($(".video-js-custom.video-js:not(.vjs-playing)").length 
                            ||$(".video-js-custom.video-js:not(.vjs-user-inactive)").length ){
                        $scope.hidingToolbar = false;
                        $scope.updateTextTrackDisplay();
                    }
                }else{
                    if($(".video-js-custom.video-js.vjs-playing.vjs-user-inactive").length){
                        $scope.hidingToolbar = true;
                        $scope.updateTextTrackDisplay();
                    }
                }
                $scope.updateTimeout = $timeout($scope.makeUpdate, 30);
            };
            $scope.updateAudioTrackIcon = function () {
                //console.log("updateAudioTrackIcon()");
                //Prevent this code if currently sorting audioTracks
                if (!$scope.metadataloaded){
                    return;
                }
                //
                var playerAudioTracks = player.audioTracks();
                if (playerAudioTracks !== null && playerAudioTracks.length > 0) {
                    //console.log("playerAudioTracks.length: "+playerAudioTracks.length);
                    var audioTrackList = null;
                    if(player.tech_.featuresNativeAudioTracks){
                        //console.log("Using Native audioTracks");
                        var video = $(".video-js-custom.video-js video.vjs-tech")[0];
                        audioTrackList = video.audioTracks;
                    }
                    //search for main track
                    var mainId = "";
                    for (var i = 0; i < playerAudioTracks.length; i++) {
                        if("main" ===playerAudioTracks[i].kind){
                            mainId = playerAudioTracks[i].id;
                        }
                    };
                    if(!mainId){
                        if(audioTrackList !== undefined && audioTrackList!==null && audioTrackList.length > 0){
                            mainId = audioTrackList[0].id;
                        }else{
                            mainId = playerAudioTracks[0].id;
                        }
                    }
                    //console.log("mainId: "+mainId);
                    //Search for enabledId emulated tracks
                    var enabledId = "";
                    for (var i = 0; i < playerAudioTracks.length; i++) {
                        if(playerAudioTracks[i].enabled){
                            enabledId = playerAudioTracks[i].id;
                        }
                    };
                    //If no track is enabled then enable the main track
                    if(!enabledId){
                        enabledId = mainId;
                        playerAudioTracks.getTrackById(enabledId).enabled = true;
                    }
                    //console.log("enabledId: "+enabledId);
                    // Make json copy of tracks
                    var jsonAudioTracks =[];
                    for (var i = 0; i < playerAudioTracks.length; i++) {
                        var jsonAudioTrack = {id: playerAudioTracks[i].id,kind: playerAudioTracks[i].kind,label: playerAudioTracks[i].label,language: playerAudioTracks[i].language, enabled: enabledId===playerAudioTracks[i].id};
                        jsonAudioTracks.push(jsonAudioTrack);
                    };

                    //Set main track kind to main and look for other audio in same language and set kind to main-desc for sorting
                    var mainLabel = jsonAudioTracks.find(item => item.id === mainId).label.toLowerCase();
                    for (var i = 0; i < playerAudioTracks.length; i++) {
                        if(playerAudioTracks[i].id === mainId){
                            jsonAudioTracks.find(item => item.id === playerAudioTracks[i].id).kind="main";
                        }else if(playerAudioTracks[i].label.toLowerCase().includes(mainLabel)){
                            jsonAudioTracks.find(item => item.id === playerAudioTracks[i].id).kind="main-desc";
                        }
                    };
                    //console.log("jsonAudioTracks:\n"+JSON.stringify(jsonAudioTracks, null, 2));
                    // Make sorted json copy of tracks
                    var sortedJsonAudioTracks = null;
                    if (typeof structuredClone === 'function') {
                        sortedJsonAudioTracks = structuredClone(jsonAudioTracks);
                    } else {
                        sortedJsonAudioTracks = JSON.parse(JSON.stringify(jsonAudioTracks));
                    }
                    sortedJsonAudioTracks.sort((a,b) => {
                        var kindComparison = a.kind.localeCompare(b.kind);
                        if(kindComparison !==0 ){
                            if(a.kind === "main"){
                                return -1;
                            }
                            if(b.kind === "main"){
                                return 1;
                            }
                            if(a.kind === "main-desc"){
                                return -1;
                            }
                            if(b.kind === "main-desc"){
                                return 1;
                            }
                        }
                        return a.label.localeCompare(b.label);
                    });
                    //console.log("sortedJsonAudioTracks:\n"+JSON.stringify(sortedJsonAudioTracks, null, 2));
                    // if json copy and sorted json copy are not the same then replace tracks with sorted
                    if(JSON.stringify(jsonAudioTracks) !== JSON.stringify(sortedJsonAudioTracks)){
                        //console.log("start sorting");
                        //console.log("jsonAudioTracks:\n"+JSON.stringify(jsonAudioTracks, null, 2));
                        //console.log("sortedJsonAudioTracks:\n"+JSON.stringify(sortedJsonAudioTracks, null, 2));
                        sortedJsonAudioTracks.forEach(track =>{
                            var tempTrack = playerAudioTracks.getTrackById(track.id);
                            player.audioTracks().removeTrack(tempTrack);
                            player.audioTracks().addTrack(tempTrack);
                            //console.log("move "+ track.label);
                        });
                        //console.log("stop sorting");
                    }
                    // Update each playerAudioTrack.label and find label for class tag
                    var enabledLabel = "";
                    for (var i = 0; i < playerAudioTracks.length; i++) {

                        var track = playerAudioTracks[i];
                        //console.log("Track["+i+"]- id:"+track.id+", kind:"+track.kind+", label:"+track.label+", language:"+track.language+", enabled:"+track.enabled);
                        if(!player.tech_.featuresNativeAudioTracks){
                            playerAudioTracks[i].label = playerAudioTracks[i].label.replace("(Audio Description)","[AD]");
                        }
                        var label = playerAudioTracks[i].label.split(" ")[0].toLowerCase();
                        $(".video-js-custom.video-js .vjs-audio-button button").removeClass("vjs-audio-" + label);
                        if (playerAudioTracks[i].enabled) {
                            enabledLabel = label;
                        }
                    }
                    //console.log("enabledLabel: "+enabledLabel);
                    if(enabledLabel){
                        $(".video-js-custom.video-js .vjs-audio-button button").addClass("vjs-audio-" + enabledLabel);
                    }
                    $(".vjs-menu .vjs-menu-item").off("keydown.quizzing");
                    //Catch menu keydown and set focus
                    $(".vjs-menu .vjs-menu-item").on("keydown.quizzing", function(event){
                        if(27===event.which){
                            $(".vjs-menu.vjs-lock-showing").parent().children("button:visible").focus();
                        }
                    });
                    $(".video-js-custom.video-js .vjs-audio-button .vjs-menu")
                          .attr("id","vjs-audio-menu-id")
                          .attr("aria-labelledby","vjs-audio-button-id");
                }
            };
            $scope.showTooltip = function(e){
                $(".vjs-button").removeClass("vjs-tooltip-show");
                if($(e.target).is(".vjs-volume-control")){
                    $(e.target).addClass("vjs-tooltip-show");
                }else if($(e.target).is(".vjs-volume-bar")){
                    $(e.target).parents(".vjs-volume-control:first").addClass("vjs-tooltip-show");
                }else if($(e.target).is(".vjs-button")){
                    $(e.target).addClass("vjs-tooltip-show");
                }else{
                    $(e.target).parents(".vjs-button:first").addClass("vjs-tooltip-show");
                }
            };
            $scope.hideTooltip = function(e){
                if($(e.target).is(".vjs-volume-control")){
                    $(e.target).removeClass("vjs-tooltip-show");
                }else if($(e.target).is(".vjs-volume-bar")){
                    $(e.target).parents(".vjs-volume-control:first").removeClass("vjs-tooltip-show");
                }else if($(e.target).is(".vjs-button")){
                    $(e.target).removeClass("vjs-tooltip-show");
                }else{
                    $(e.target).parents(".vjs-button:first").removeClass("vjs-tooltip-show");
                }
            };
            $scope.toggleCC = function(){
                if($scope.captionsIncluded && !$scope.subtitlesIncluded && !$scope.audioDescriptionsIncluded){
                    var isShowing = false;
                    var textTrackList = player.textTracks();
                    for (var i = 0; i < textTrackList.length; i++) {
                        var track = textTrackList[i];
                        if (track.mode === 'showing') {
                            isShowing = true;
                            break;
                        }
                    }
                    for (var i = 0; i < textTrackList.length; i++) {
                        var track = textTrackList[i];
                        if(track.kind==="captions"){
                            if(isShowing){
                                track.mode = 'disabled';
                            }else{
                                track.mode = 'showing';
                            }
                        }
                    }
                }
            };
            $scope.toggleToggleTip = function(e){
                if($(e.target).hasClass("show-toggletip")){
                    $(".toggletip-button").removeClass("show-toggletip").attr("aria-expanded","false");
                    $(".aria-live-announce").html("");
                }else{
                    $(e.target).addClass("show-toggletip").attr("aria-expanded","true");
                    $(e.target).next().find('[tabindex="0"]').focus();
                    $(".aria-live-announce").html("How ShareStream calculates average score.  " +
                        "ShareStream rounds the average score and points for a quiz to the nearest hundredth (two decimal places).  " +
                        "Because of this, average scores and points may differ slightly from their unrounded values.");
                }
            };
            $scope.closeToggleTips = function(e){
                if("keydown" === e.type && 27 === e.which){
                    $(".toggletip-button").removeClass("show-toggletip").attr("aria-expanded","false");
                    $(".aria-live-announce").html("");
                } else if(!$(e.target).hasClass("toggletip-button") && !$(e.target).hasClass("toggletip") && $(e.target).parents(".toggletip").length===0){
                    $(".toggletip-button").removeClass("show-toggletip").attr("aria-expanded","false");
                    $(".aria-live-announce").html("");
                }
            };
            $scope.handleBreadcrumbEllipsisClick = function(e) {
                $(e.target).parents('.breadcrumb').find('.breadcrumb-menu').toggle();

                setTimeout(function(){
                    if($(e.target).parents('.breadcrumb').find('.breadcrumb-menu').is(':visible')) {
                        var intervalId = setInterval(function(){
                            if($('.breadcrumb-menu li:nth-child(1) > div > span')[0].offsetWidth) {
                                clearInterval(intervalId);

                                //check each LI if there's ellipsis
                                for(var i = 0; i < $('.breadcrumb-menu li').length; i++) {
                                    if(hasEllipsisWidth($('.breadcrumb-menu li:nth-child(' + (i + 1) + ') > div > span')[0])) {
                                        $scope.crumbsForMenu[i].hasEllipsis = true;
                                    } else {
                                        $scope.crumbsForMenu[i].hasEllipsis = false;
                                    }
                                }
                            }
                        }, 100);
                        $(e.target).parents('.breadcrumb').find('.breadcrumb-menu').find('[tabindex="0"]').first().focus();
                        $(e.target).parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",true);
                    }else{
                        $(e.target).parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",false);
                    }
                }, 100);
            };
            $scope.handleBreadcrumbMenuItemClick = function(e, cid) {
                $scope.navigateToCollection({type: 'Collection', xid: cid});
                $(e.target).parents('.breadcrumb').find('.breadcrumb-menu').hide();
                $(e.target).parents('.breadcrumb').find('.elipse').attr("aria-expanded",false);
            };
            $scope.$watch('[parent, asset]', function(){
                if($scope.parent && $scope.asset){
                    // Get a few assets from the same parent collection to display in the sidebar
                    AssetService.GetAllAssets.get({cid: $scope.parent.cid, isActive: $scope.asset.isActive}, function (assetList) {
                        $scope.assets = assetList.assets;

                        setTimeout(() => {
                            //Add ellipsis for long titles
                            $('.sidebar-courses .course-title a').each((index, item) => {
                                $clamp(item, {clamp: 2});
                            });

                            //Add tooltip if there's ellipsis in title
                            $('.sidebar-courses .course-title a').each((index, item) => {
                                if(hasEllipsisHeight(item)) {
                                    $scope.assets[index].hasEllipsis = true;
                                }
                            });

                        }, 0)
                    });
                }
            });
            $scope.hideBreadcrumbMenuWhenClickOutside = function(e){
                if(!$(e.target).hasClass("breadcrumb-menu") &&
                    $(e.target).parents(".breadcrumb-menu").length ===0 &&
                    !$(e.target).hasClass("ellipsis") &&
                    $(e.target).parents(".ellipsis").length === 0){
                    if($(".breadcrumb-menu").is(":visible")){
                        $(".breadcrumb-menu:visible").parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",false);
                        $('.breadcrumb-menu').hide();
                    }
                }
            };
            $scope.updateTextTrackDisplay = function(){
                if(player && player.textTrackDisplay){
                    $timeout(function(){
                        player.textTrackDisplay.updateDisplay();
                    });
                }
            }
            $(window).on("click.instructorreport", function (e) {
                $scope.closeToggleTips(e);
                $scope.hideBreadcrumbMenuWhenClickOutside(e);
            });
            $(document).on("keydown.instructorreport", function (e) {
                if(27 === e.which){
                    if($(".toggletip-button.show-toggletip").length > 0){
                        $(".toggletip-button.show-toggletip").focus();
                    }
                    $scope.closeToggleTips(e);
                    $(".vjs-button").removeClass("vjs-tooltip-show");
                    $(".vjs-volume-control").removeClass("vjs-tooltip-show");
                    if($(".breadcrumb-menu").is(":visible")){
                        $(".breadcrumb-menu:visible").parents('.breadcrumb').find('.ellipsis').first().focus();
                        $(".breadcrumb-menu:visible").parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",false);
                        $('.breadcrumb-menu').hide();
                    }
                    if($("#vjs-more-actions-dialog-id").hasClass("vjs-lock-showing")){
                        $("#vjs-more-actions-button-id").focus();
                        $scope.closeMoreActionsDialog();
                    }
                }
            });
            $(document).on("keyup.instructorreport", function (e) {
                if(9 === e.which){
                    $scope.closeToggleTips(e);
                }
            });
            $(window).on("blur.instructorreport", function (e){
                $scope.closeToggleTips(e);
            });
            $scope.$on('$destroy', function() {
                console.log('quizzing-instructor-report.controller.js controller is being destroyed, performing cleanup...');
                $scope.resizeObserver.unobserve($scope.playerEl);
                $(window).off("click.instructorreport");
                $(document).off("keydown.instructorreport");
                $(document).off("keyup.instructorreport");
                $(window).off("blur.instructorreport");
                $timeout.cancel($scope.updateTimeout);
                $(".vjs-menu .vjs-menu-item").off("keydown.instructorreport");
            });
        });
    });
